import React, { SyntheticEvent } from "react";

import "./SelectItem.css";

type SelectElT = {
  [key: string]: string;
};

interface SelectProps {
  el: SelectElT;
  category: string;
  onSelectChange: (e: SyntheticEvent) => void;
  konfigured: any;
  name: string;
  checked?: boolean;
  id: string;
}

const SelectItem = React.forwardRef<HTMLInputElement, SelectProps>((props, ref)  => 
    <div className="SelectItem">
      <input
        id={props.id}
        ref={ref}
        onChange={(e) => props.onSelectChange(e)}
        type='radio'
        className="SelectItem-input"
        name={props.name}
        value={props.el.id}
        checked={props.konfigured[props.category] === props.el.id.toString()}
      />
      <label htmlFor={props.id}>
        <div className="SelectItem-imgbox">
          <img
            className="SelectItem-img"
            src={props.el.picture_choose}
            alt=""
          />
          <div className="SelectItem-icon">
            <i className="icofont-check-alt"></i>
          </div>
        </div>
        <div className="SelectItem-underline"></div>
        <p className="SelectItem-title">{props.el.title}</p>
      </label>
    </div>
  );

export default SelectItem;
